import FilterList from "components/Blocks/FilterList/FilterList";

export default FilterList;
